export default __webpack_public_path__ + "assets/images/245e1337441a985ea803e9483aeb6f93.jpg";